import { useMutation, useQuery } from "@tanstack/react-query";
import { lineApiService } from "modules/Pharmacy/LineClearance/api/lineclearance.api";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useLineClearanceService = ({
  searchtext,
  currentpage = 1,
  pagesize = 5,
  studyid,
  periodid,
  lineclearanceid,
  getDropdown = false
}: {
  searchtext?: string | null;
  currentpage?: number;
  pagesize?: number;
  studyid?: number | null;
  periodid?: number | null;
  lineclearanceid?: number | null;
  getDropdown?: boolean;
} = {}) => {
  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => lineApiService.insertData(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) => lineApiService.updateData(payload),
  });

  const SelectAllQuery = useQuery<ApiResponse, Error>({
    queryKey: ["line-clearance-select-all", searchtext, currentpage, pagesize, studyid, periodid],
    queryFn: () => lineApiService.selectAllData(searchtext, currentpage, pagesize, studyid, periodid),
    enabled: !!currentpage && !!pagesize && !!periodid,
  });

  const SelectQuery = useQuery<ApiResponse, Error>({
    queryKey: ["line-clearance-select", lineclearanceid],
    queryFn: () => lineApiService.selectData(lineclearanceid),
    enabled: !!lineclearanceid,
  });

  const DropdownQuery = useQuery<ApiResponse, Error>({
    queryKey: ["ip-verified-dropdown"],
    queryFn: () => lineApiService.Dropdown(),
    enabled: !!getDropdown,
  });

  const DeleteMutation = useMutation<ApiResponse, Error, { lineclearanceid: number | null; updatereason: string }>({
    mutationFn: (payload) => lineApiService.deleteData(payload),
  });

  const verifyPinMutation = useMutation<ApiResponse, Error, { verifypin: string; lineclearanceid: number; studyid: number; verifiedby: number }>({
    mutationFn: (payload) => lineApiService.verifyPin(payload),
  });

  return { InsertMutation, UpdateMutation, DeleteMutation, verifyPinMutation, SelectAllQuery, SelectQuery, DropdownQuery };
};

